/**
 * com.remedirx.apps.MyRemedi
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { AggregateData } from '../model/aggregateData';
import { ApiRequestDto } from '../model/apiRequestDto';
import { AverageData } from '../model/averageData';
import { MedicationSummaryCountResult } from '../model/medicationSummaryCountResult';
import { MedicationSummaryResidentContainer } from '../model/medicationSummaryResidentContainer';
import { PRNPsychoactiveResidentCountResult } from '../model/pRNPsychoactiveResidentCountResult';
import { ResidentCountResult } from '../model/residentCountResult';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class PsychotropicSummaryService {

    protected basePath = 'http://localhost:3402';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * Residents that have more than PRN psychotropic Medication
     * The list will show a one to one mapping of each resident to a specific medication        Sample Call      http://URL/api/Psychotropic/MultiplePRNPsychotropicOrdersByResident
     * @param requestParameters Contains request parameters: orgList, startDate, endDate
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public psychotropicSummaryGetMultiplePRNPsychotropicOrdersByResident(requestParameters: ApiRequestDto, observe?: 'body', reportProgress?: boolean): Observable<Array<AggregateData>>;
    public psychotropicSummaryGetMultiplePRNPsychotropicOrdersByResident(requestParameters: ApiRequestDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<AggregateData>>>;
    public psychotropicSummaryGetMultiplePRNPsychotropicOrdersByResident(requestParameters: ApiRequestDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<AggregateData>>>;
    public psychotropicSummaryGetMultiplePRNPsychotropicOrdersByResident(requestParameters: ApiRequestDto, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (requestParameters === null || requestParameters === undefined) {
            throw new Error('Required parameter requestParameters was null or undefined when calling psychotropicSummaryGetMultiplePRNPsychotropicOrdersByResident.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml',
            'application/x-www-form-urlencoded'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<Array<AggregateData>>(`${this.basePath}/api/Psychotropic/MultiplePRNPsychotropicOrdersByResident`,
            requestParameters,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Multiple Psychotropics In Same Drug Category By Drug Group  (category).
     * Displays top 4 drug groups with the fifth group being \&quot;other\&quot; if a single facility is passed.     If multiple facilities are passed in, the top drug groups are return.  Within each drug group, the facilities making up the top  5 (with #5 being other group if more than 5 facilities are passed in) will be display.  Item count under each facility is the  count of psychotropic that facility has that belongs to that drug group.          Sample Call      http://URL/api/Psychotropic/GetMultiplePsychotropicsInSameDrugCategoryByDrugGroup
     * @param requestParameters Contains request parameters: orgList, startDate, endDate
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public psychotropicSummaryGetMultiplePsychotropicsInSameDrugCategoryByDrugGroup(requestParameters: ApiRequestDto, observe?: 'body', reportProgress?: boolean): Observable<Array<AggregateData>>;
    public psychotropicSummaryGetMultiplePsychotropicsInSameDrugCategoryByDrugGroup(requestParameters: ApiRequestDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<AggregateData>>>;
    public psychotropicSummaryGetMultiplePsychotropicsInSameDrugCategoryByDrugGroup(requestParameters: ApiRequestDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<AggregateData>>>;
    public psychotropicSummaryGetMultiplePsychotropicsInSameDrugCategoryByDrugGroup(requestParameters: ApiRequestDto, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (requestParameters === null || requestParameters === undefined) {
            throw new Error('Required parameter requestParameters was null or undefined when calling psychotropicSummaryGetMultiplePsychotropicsInSameDrugCategoryByDrugGroup.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml',
            'application/x-www-form-urlencoded'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<Array<AggregateData>>(`${this.basePath}/api/Psychotropic/GetMultiplePsychotropicsInSameDrugCategoryByDrugGroup`,
            requestParameters,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Psychotropic Medication grouped by facility
     * Queries Antibiotics and returns groupings by facility and then within each facility by drug group.    Count of each group is stored in ItemCount        Sample Call      http://URL/api/Psychotropic/GetMultiplePsychotropicsInSameDrugCategoryByFacility
     * @param requestParameters Contains request parameters: orgList, startDate, endDate
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public psychotropicSummaryGetMultiplePsychotropicsInSameDrugCategoryByFacility(requestParameters: ApiRequestDto, observe?: 'body', reportProgress?: boolean): Observable<Array<AggregateData>>;
    public psychotropicSummaryGetMultiplePsychotropicsInSameDrugCategoryByFacility(requestParameters: ApiRequestDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<AggregateData>>>;
    public psychotropicSummaryGetMultiplePsychotropicsInSameDrugCategoryByFacility(requestParameters: ApiRequestDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<AggregateData>>>;
    public psychotropicSummaryGetMultiplePsychotropicsInSameDrugCategoryByFacility(requestParameters: ApiRequestDto, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (requestParameters === null || requestParameters === undefined) {
            throw new Error('Required parameter requestParameters was null or undefined when calling psychotropicSummaryGetMultiplePsychotropicsInSameDrugCategoryByFacility.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml',
            'application/x-www-form-urlencoded'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<Array<AggregateData>>(`${this.basePath}/api/Psychotropic/GetMultiplePsychotropicsInSameDrugCategoryByFacility`,
            requestParameters,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Psychotropic Medication grouped by prescriber.
     * This should be used only when a single org unit is selected in the UI.  When multiple org units are selected this call can&#39;t be used  and a different call should be used.    Results will be grouped by Drug Group and then within each group the top 4 prescribers with the 5th being \&quot;Other if there are more than   5 unique prescribers        Sample Call      http://URL/api/Psychotropic/GetMultiplePsychotropicsInSameDrugCatetoryByPrescriber
     * @param requestParameters Contains request parameters: orgList, startDate, endDate
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public psychotropicSummaryGetMultiplePsychotropicsInSameDrugCategoryByPrescriber(requestParameters: ApiRequestDto, observe?: 'body', reportProgress?: boolean): Observable<Array<AggregateData>>;
    public psychotropicSummaryGetMultiplePsychotropicsInSameDrugCategoryByPrescriber(requestParameters: ApiRequestDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<AggregateData>>>;
    public psychotropicSummaryGetMultiplePsychotropicsInSameDrugCategoryByPrescriber(requestParameters: ApiRequestDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<AggregateData>>>;
    public psychotropicSummaryGetMultiplePsychotropicsInSameDrugCategoryByPrescriber(requestParameters: ApiRequestDto, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (requestParameters === null || requestParameters === undefined) {
            throw new Error('Required parameter requestParameters was null or undefined when calling psychotropicSummaryGetMultiplePsychotropicsInSameDrugCategoryByPrescriber.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml',
            'application/x-www-form-urlencoded'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<Array<AggregateData>>(`${this.basePath}/api/Psychotropic/GetMultiplePsychotropicsInSameDrugCategoryByPrescriber`,
            requestParameters,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Raw data for Psychotropics (Grid Data).
     * This returns Psychotropics.  Data in this call is not aggregated.        Sample Call      http://URL/api/Psychotropic/GetMultiplePsychotropicsInSameDrugCatetoryData
     * @param requestParameters Contains request parameters: orgList, startDate, endDate, sortFilterDto
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public psychotropicSummaryGetMultiplePsychotropicsInSameDrugCategoryData(requestParameters: ApiRequestDto, observe?: 'body', reportProgress?: boolean): Observable<MedicationSummaryResidentContainer>;
    public psychotropicSummaryGetMultiplePsychotropicsInSameDrugCategoryData(requestParameters: ApiRequestDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MedicationSummaryResidentContainer>>;
    public psychotropicSummaryGetMultiplePsychotropicsInSameDrugCategoryData(requestParameters: ApiRequestDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MedicationSummaryResidentContainer>>;
    public psychotropicSummaryGetMultiplePsychotropicsInSameDrugCategoryData(requestParameters: ApiRequestDto, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (requestParameters === null || requestParameters === undefined) {
            throw new Error('Required parameter requestParameters was null or undefined when calling psychotropicSummaryGetMultiplePsychotropicsInSameDrugCategoryData.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml',
            'application/x-www-form-urlencoded'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<MedicationSummaryResidentContainer>(`${this.basePath}/api/Psychotropic/GetMultiplePsychotropicsInSameDrugCategoryData`,
            requestParameters,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Percentage of residents on  Psychotropic Medication
     * Percentage of total residents in the selected facilities against the number of residents on IV antibiotics in the selected date range                   Sample Call     http://URL/api/Psychotropic/GetMultiplePsychotropicsInSameDrugCategoryPercentage
     * @param requestParameters Contains request parameters: orgList, startDate, endDate
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public psychotropicSummaryGetMultiplePsychotropicsInSameDrugCategoryPercentage(requestParameters: ApiRequestDto, observe?: 'body', reportProgress?: boolean): Observable<ResidentCountResult>;
    public psychotropicSummaryGetMultiplePsychotropicsInSameDrugCategoryPercentage(requestParameters: ApiRequestDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ResidentCountResult>>;
    public psychotropicSummaryGetMultiplePsychotropicsInSameDrugCategoryPercentage(requestParameters: ApiRequestDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ResidentCountResult>>;
    public psychotropicSummaryGetMultiplePsychotropicsInSameDrugCategoryPercentage(requestParameters: ApiRequestDto, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (requestParameters === null || requestParameters === undefined) {
            throw new Error('Required parameter requestParameters was null or undefined when calling psychotropicSummaryGetMultiplePsychotropicsInSameDrugCategoryPercentage.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml',
            'application/x-www-form-urlencoded'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<ResidentCountResult>(`${this.basePath}/api/Psychotropic/GetMultiplePsychotropicsInSameDrugCategoryPercentage`,
            requestParameters,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Returns raw data for the PRN Psychoactive medication grid. The data is not aggregated.
     * Data in this call is not aggregated.        Sample Call      http://URL/api/MedicationSummary/GetPRNPsychoactive
     * @param requestParameters Contains request parameters: orgList, startDate, endDate, sortFilterDto
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public psychotropicSummaryGetPRNPsychoactive(requestParameters: ApiRequestDto, observe?: 'body', reportProgress?: boolean): Observable<MedicationSummaryResidentContainer>;
    public psychotropicSummaryGetPRNPsychoactive(requestParameters: ApiRequestDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MedicationSummaryResidentContainer>>;
    public psychotropicSummaryGetPRNPsychoactive(requestParameters: ApiRequestDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MedicationSummaryResidentContainer>>;
    public psychotropicSummaryGetPRNPsychoactive(requestParameters: ApiRequestDto, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (requestParameters === null || requestParameters === undefined) {
            throw new Error('Required parameter requestParameters was null or undefined when calling psychotropicSummaryGetPRNPsychoactive.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml',
            'application/x-www-form-urlencoded'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<MedicationSummaryResidentContainer>(`${this.basePath}/api/Psychotropic/GetPRNPsychoactive`,
            requestParameters,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Returns PRN Psychoactive medication groups, top 4 with the fifth group being \&quot;other\&quot;
     * Displays top 4 drug groups with the fifth group being \&quot;other\&quot; if a single facility is passed.     If multiple facilities are passed in, the top drug groups are return.  Within each drug group, the facilities making up the top  5 (with #5 being other group if more than 5 facilities are passed in) will be display.  Item count under each facility is the  count of anticoagulant medications that facility has that belongs to that drug group.          Sample Call      http://URL/api/MedicationSummary/GetPRNPsychoactiveByDrugGroup
     * @param requestParameters Contains request parameters: orgList, startDate, endDate
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public psychotropicSummaryGetPRNPsychoactiveByDrugGroup(requestParameters: ApiRequestDto, observe?: 'body', reportProgress?: boolean): Observable<Array<AggregateData>>;
    public psychotropicSummaryGetPRNPsychoactiveByDrugGroup(requestParameters: ApiRequestDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<AggregateData>>>;
    public psychotropicSummaryGetPRNPsychoactiveByDrugGroup(requestParameters: ApiRequestDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<AggregateData>>>;
    public psychotropicSummaryGetPRNPsychoactiveByDrugGroup(requestParameters: ApiRequestDto, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (requestParameters === null || requestParameters === undefined) {
            throw new Error('Required parameter requestParameters was null or undefined when calling psychotropicSummaryGetPRNPsychoactiveByDrugGroup.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml',
            'application/x-www-form-urlencoded'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<Array<AggregateData>>(`${this.basePath}/api/Psychotropic/GetPRNPsychoactiveByDrugGroup`,
            requestParameters,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Returns PRN Psychoactive medications grouped by facility
     * Queries Anticoagulant medications and returns groupings by facility and then within each facility by drug group.    Count of each group is stored in ItemCount        Sample Call      http://URL/api/MedicationSummary/GetPRNPsychoactiveByFacility
     * @param requestParameters Contains request parameters: orgList, startDate, endDate
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public psychotropicSummaryGetPRNPsychoactiveByFacility(requestParameters: ApiRequestDto, observe?: 'body', reportProgress?: boolean): Observable<Array<AggregateData>>;
    public psychotropicSummaryGetPRNPsychoactiveByFacility(requestParameters: ApiRequestDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<AggregateData>>>;
    public psychotropicSummaryGetPRNPsychoactiveByFacility(requestParameters: ApiRequestDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<AggregateData>>>;
    public psychotropicSummaryGetPRNPsychoactiveByFacility(requestParameters: ApiRequestDto, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (requestParameters === null || requestParameters === undefined) {
            throw new Error('Required parameter requestParameters was null or undefined when calling psychotropicSummaryGetPRNPsychoactiveByFacility.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml',
            'application/x-www-form-urlencoded'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<Array<AggregateData>>(`${this.basePath}/api/Psychotropic/GetPRNPsychoactiveByFacility`,
            requestParameters,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Returns PRN Psychoactive medication grouped by prescriber.
     * Queries Anticoagulant medications and returns groupings by Presciber and then facility.    Count of each group is stored in ItemCount        Sample Call      http://URL/api/MedicationSummary/GetPRNPsychoactiveByPrescriber
     * @param requestParameters Contains request parameters: orgList, startDate, endDate
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public psychotropicSummaryGetPRNPsychoactiveByPrescriber(requestParameters: ApiRequestDto, observe?: 'body', reportProgress?: boolean): Observable<Array<AggregateData>>;
    public psychotropicSummaryGetPRNPsychoactiveByPrescriber(requestParameters: ApiRequestDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<AggregateData>>>;
    public psychotropicSummaryGetPRNPsychoactiveByPrescriber(requestParameters: ApiRequestDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<AggregateData>>>;
    public psychotropicSummaryGetPRNPsychoactiveByPrescriber(requestParameters: ApiRequestDto, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (requestParameters === null || requestParameters === undefined) {
            throw new Error('Required parameter requestParameters was null or undefined when calling psychotropicSummaryGetPRNPsychoactiveByPrescriber.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml',
            'application/x-www-form-urlencoded'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<Array<AggregateData>>(`${this.basePath}/api/Psychotropic/GetPRNPsychoactiveByPrescriber`,
            requestParameters,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Returns percentage of residents with PRN Psychoactive orders.
     * Sample Call  http://URL/api/MedicationSummary/GetPRNPsychoactivePercentage
     * @param requestParameters Contains request parameters: orgList, startDate, endDate
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public psychotropicSummaryGetPRNPsychoactivePercentage(requestParameters: ApiRequestDto, observe?: 'body', reportProgress?: boolean): Observable<PRNPsychoactiveResidentCountResult>;
    public psychotropicSummaryGetPRNPsychoactivePercentage(requestParameters: ApiRequestDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<PRNPsychoactiveResidentCountResult>>;
    public psychotropicSummaryGetPRNPsychoactivePercentage(requestParameters: ApiRequestDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<PRNPsychoactiveResidentCountResult>>;
    public psychotropicSummaryGetPRNPsychoactivePercentage(requestParameters: ApiRequestDto, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (requestParameters === null || requestParameters === undefined) {
            throw new Error('Required parameter requestParameters was null or undefined when calling psychotropicSummaryGetPRNPsychoactivePercentage.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml',
            'application/x-www-form-urlencoded'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<PRNPsychoactiveResidentCountResult>(`${this.basePath}/api/Psychotropic/GetPRNPsychoactivePercentage`,
            requestParameters,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Psychotropic Burden Per Resident by Drug Class
     * The list will show a one to one mapping of each resident to a specific medication        Sample Call      http://URL/api/Psychotropic/GetPsychotropicBurdenPerResidentByDrugGroup
     * @param requestParameters Contains request parameters: orgList, startDate, endDate
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public psychotropicSummaryGetPsychotropicBurdenPerResidentByDrugClass(requestParameters: ApiRequestDto, observe?: 'body', reportProgress?: boolean): Observable<Array<AverageData>>;
    public psychotropicSummaryGetPsychotropicBurdenPerResidentByDrugClass(requestParameters: ApiRequestDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<AverageData>>>;
    public psychotropicSummaryGetPsychotropicBurdenPerResidentByDrugClass(requestParameters: ApiRequestDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<AverageData>>>;
    public psychotropicSummaryGetPsychotropicBurdenPerResidentByDrugClass(requestParameters: ApiRequestDto, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (requestParameters === null || requestParameters === undefined) {
            throw new Error('Required parameter requestParameters was null or undefined when calling psychotropicSummaryGetPsychotropicBurdenPerResidentByDrugClass.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml',
            'application/x-www-form-urlencoded'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<Array<AverageData>>(`${this.basePath}/api/Psychotropic/GetPsychotropicBurdenPerResidentByDrugClass`,
            requestParameters,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Psychotropic Burden Per Resident by Facility
     * The list will show a one to one mapping of each resident to a specific medication        Sample Call      http://URL/api/Psychotropic/GetPsychotropicBurdenPerResidentByFacility
     * @param requestParameters Contains request parameters: orgList, startDate, endDate
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public psychotropicSummaryGetPsychotropicBurdenPerResidentByFacility(requestParameters: ApiRequestDto, observe?: 'body', reportProgress?: boolean): Observable<Array<AverageData>>;
    public psychotropicSummaryGetPsychotropicBurdenPerResidentByFacility(requestParameters: ApiRequestDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<AverageData>>>;
    public psychotropicSummaryGetPsychotropicBurdenPerResidentByFacility(requestParameters: ApiRequestDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<AverageData>>>;
    public psychotropicSummaryGetPsychotropicBurdenPerResidentByFacility(requestParameters: ApiRequestDto, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (requestParameters === null || requestParameters === undefined) {
            throw new Error('Required parameter requestParameters was null or undefined when calling psychotropicSummaryGetPsychotropicBurdenPerResidentByFacility.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml',
            'application/x-www-form-urlencoded'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<Array<AverageData>>(`${this.basePath}/api/Psychotropic/GetPsychotropicBurdenPerResidentByFacility`,
            requestParameters,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Psychotropic Burden Per Resident by prescriber
     * The list will show a one to one mapping of each resident to a specific medication        Sample Call      http://URL/api/Psychotropic/GetPsychotropicBurdenPerResidentByPrescriber?startDate&#x3D;2016-1-1T12:30:00&amp;amp;endDate&#x3D;2017-2-1T12:30:00&amp;amp;orgList&#x3D;10wilm
     * @param startDate Date to start searching for data from
     * @param endDate Stop Date
     * @param orgUnit Organizational Unit to return data for, should be a list of facilities and should not contain a region
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public psychotropicSummaryGetPsychotropicBurdenPerResidentByPrescriber(startDate: string, endDate: string, orgUnit: string, observe?: 'body', reportProgress?: boolean): Observable<Array<AverageData>>;
    public psychotropicSummaryGetPsychotropicBurdenPerResidentByPrescriber(startDate: string, endDate: string, orgUnit: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<AverageData>>>;
    public psychotropicSummaryGetPsychotropicBurdenPerResidentByPrescriber(startDate: string, endDate: string, orgUnit: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<AverageData>>>;
    public psychotropicSummaryGetPsychotropicBurdenPerResidentByPrescriber(startDate: string, endDate: string, orgUnit: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (startDate === null || startDate === undefined) {
            throw new Error('Required parameter startDate was null or undefined when calling psychotropicSummaryGetPsychotropicBurdenPerResidentByPrescriber.');
        }

        if (endDate === null || endDate === undefined) {
            throw new Error('Required parameter endDate was null or undefined when calling psychotropicSummaryGetPsychotropicBurdenPerResidentByPrescriber.');
        }

        if (orgUnit === null || orgUnit === undefined) {
            throw new Error('Required parameter orgUnit was null or undefined when calling psychotropicSummaryGetPsychotropicBurdenPerResidentByPrescriber.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (startDate !== undefined && startDate !== null) {
            queryParameters = queryParameters.set('startDate', <any>startDate);
        }
        if (endDate !== undefined && endDate !== null) {
            queryParameters = queryParameters.set('endDate', <any>endDate);
        }
        if (orgUnit !== undefined && orgUnit !== null) {
            queryParameters = queryParameters.set('orgUnit', <any>orgUnit);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<Array<AverageData>>(`${this.basePath}/api/Psychotropic/GetPsychotropicBurdenPerResidentByPrescriber`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Grid data of Psychotropic Burden Per Resident
     * The list will show a one to one mapping of each resident to a specific medication        Sample Call      http://URL/api/Psychotropic/PsychotropicBurdenPerResident
     * @param requestParameters Contains request parameters: orgList, startDate, endDate, sortFilterDto
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public psychotropicSummaryGetPsychotropicBurdenPerResidentData(requestParameters: ApiRequestDto, observe?: 'body', reportProgress?: boolean): Observable<MedicationSummaryResidentContainer>;
    public psychotropicSummaryGetPsychotropicBurdenPerResidentData(requestParameters: ApiRequestDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MedicationSummaryResidentContainer>>;
    public psychotropicSummaryGetPsychotropicBurdenPerResidentData(requestParameters: ApiRequestDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MedicationSummaryResidentContainer>>;
    public psychotropicSummaryGetPsychotropicBurdenPerResidentData(requestParameters: ApiRequestDto, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (requestParameters === null || requestParameters === undefined) {
            throw new Error('Required parameter requestParameters was null or undefined when calling psychotropicSummaryGetPsychotropicBurdenPerResidentData.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml',
            'application/x-www-form-urlencoded'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<MedicationSummaryResidentContainer>(`${this.basePath}/api/Psychotropic/PsychotropicBurdenPerResident`,
            requestParameters,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Shows the average number of Psychotropic Medications against all Residents
     * Sample Call  http://URL/api/Psychotropic/GetPsychotropicBurdenPerResidentPercentage
     * @param requestParameters Contains request parameters: orgList, startDate, endDate
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public psychotropicSummaryGetPsychotropicBurdenPerResidentPercentage(requestParameters: ApiRequestDto, observe?: 'body', reportProgress?: boolean): Observable<ResidentCountResult>;
    public psychotropicSummaryGetPsychotropicBurdenPerResidentPercentage(requestParameters: ApiRequestDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ResidentCountResult>>;
    public psychotropicSummaryGetPsychotropicBurdenPerResidentPercentage(requestParameters: ApiRequestDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ResidentCountResult>>;
    public psychotropicSummaryGetPsychotropicBurdenPerResidentPercentage(requestParameters: ApiRequestDto, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (requestParameters === null || requestParameters === undefined) {
            throw new Error('Required parameter requestParameters was null or undefined when calling psychotropicSummaryGetPsychotropicBurdenPerResidentPercentage.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml',
            'application/x-www-form-urlencoded'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<ResidentCountResult>(`${this.basePath}/api/Psychotropic/GetPsychotropicBurdenPerResidentPercentage`,
            requestParameters,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Psychtropics With No Change in Six Months by drug group (category).
     * Displays top 4 drug groups with the fifth group being \&quot;other\&quot; if a single facility is passed.     If multiple facilities are passed in, the top drug groups are return.  Within each drug group, the facilities making up the top  5 (with #5 being other group if more than 5 facilities are passed in) will be display.  Item count under each facility is the  count of antibiotics that facility has that belongs to that drug group.          Sample Call      http://URL/api/Psychotropic/GetPsychotropicOrdersWithNoChangeSixMonthsByDrugGroup
     * @param requestParameters Contains request parameters: orgList, startDate, endDate
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public psychotropicSummaryGetPsychotropicOrdersWithNoChangeSixMonthsByDrugGroup(requestParameters: ApiRequestDto, observe?: 'body', reportProgress?: boolean): Observable<Array<AggregateData>>;
    public psychotropicSummaryGetPsychotropicOrdersWithNoChangeSixMonthsByDrugGroup(requestParameters: ApiRequestDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<AggregateData>>>;
    public psychotropicSummaryGetPsychotropicOrdersWithNoChangeSixMonthsByDrugGroup(requestParameters: ApiRequestDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<AggregateData>>>;
    public psychotropicSummaryGetPsychotropicOrdersWithNoChangeSixMonthsByDrugGroup(requestParameters: ApiRequestDto, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (requestParameters === null || requestParameters === undefined) {
            throw new Error('Required parameter requestParameters was null or undefined when calling psychotropicSummaryGetPsychotropicOrdersWithNoChangeSixMonthsByDrugGroup.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml',
            'application/x-www-form-urlencoded'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<Array<AggregateData>>(`${this.basePath}/api/Psychotropic/GetPsychotropicOrdersWithNoChangeSixMonthsByDrugGroup`,
            requestParameters,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Psychtropics With No Change in Six Months grouped by facility
     * Queries Antibiotics and returns groupings by facility and then within each facility by drug group.    Count of each group is stored in ItemCount        Sample Call      http://URL/api/Psychotropic/GetPsychotropicOrdersWithNoChangeSixMonthsByFacility
     * @param requestParameters Contains request parameters: orgList, startDate, endDate
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public psychotropicSummaryGetPsychotropicOrdersWithNoChangeSixMonthsByFacility(requestParameters: ApiRequestDto, observe?: 'body', reportProgress?: boolean): Observable<Array<AggregateData>>;
    public psychotropicSummaryGetPsychotropicOrdersWithNoChangeSixMonthsByFacility(requestParameters: ApiRequestDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<AggregateData>>>;
    public psychotropicSummaryGetPsychotropicOrdersWithNoChangeSixMonthsByFacility(requestParameters: ApiRequestDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<AggregateData>>>;
    public psychotropicSummaryGetPsychotropicOrdersWithNoChangeSixMonthsByFacility(requestParameters: ApiRequestDto, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (requestParameters === null || requestParameters === undefined) {
            throw new Error('Required parameter requestParameters was null or undefined when calling psychotropicSummaryGetPsychotropicOrdersWithNoChangeSixMonthsByFacility.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml',
            'application/x-www-form-urlencoded'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<Array<AggregateData>>(`${this.basePath}/api/Psychotropic/GetPsychotropicOrdersWithNoChangeSixMonthsByFacility`,
            requestParameters,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Psychtropics With No Change in Six Months grouped by prescriber.
     * This should be used only when a single org unit is selected in the UI.  When multiple org units are selected this call can&#39;t be used  and a different call should be used.    Results will be grouped by Drug Group and then within each group the top 4 prescribers with the 5th being \&quot;Other if there are more than   5 unique prescribers        Sample Call      http://URL/api/Psychotropic/GetCDifficileAntibioticByPrescriber?startDate&#x3D;2016-1-1T12:30:00&amp;amp;endDate&#x3D;2017-2-1T12:30:00&amp;amp;orgUnit&#x3D;590
     * @param startDate Date to start searching for data from
     * @param endDate Stop Date
     * @param orgUnit Organizational unit to get data for
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public psychotropicSummaryGetPsychotropicOrdersWithNoChangeSixMonthsByPrescriber(startDate: string, endDate: string, orgUnit: string, observe?: 'body', reportProgress?: boolean): Observable<Array<AggregateData>>;
    public psychotropicSummaryGetPsychotropicOrdersWithNoChangeSixMonthsByPrescriber(startDate: string, endDate: string, orgUnit: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<AggregateData>>>;
    public psychotropicSummaryGetPsychotropicOrdersWithNoChangeSixMonthsByPrescriber(startDate: string, endDate: string, orgUnit: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<AggregateData>>>;
    public psychotropicSummaryGetPsychotropicOrdersWithNoChangeSixMonthsByPrescriber(startDate: string, endDate: string, orgUnit: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (startDate === null || startDate === undefined) {
            throw new Error('Required parameter startDate was null or undefined when calling psychotropicSummaryGetPsychotropicOrdersWithNoChangeSixMonthsByPrescriber.');
        }

        if (endDate === null || endDate === undefined) {
            throw new Error('Required parameter endDate was null or undefined when calling psychotropicSummaryGetPsychotropicOrdersWithNoChangeSixMonthsByPrescriber.');
        }

        if (orgUnit === null || orgUnit === undefined) {
            throw new Error('Required parameter orgUnit was null or undefined when calling psychotropicSummaryGetPsychotropicOrdersWithNoChangeSixMonthsByPrescriber.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (startDate !== undefined && startDate !== null) {
            queryParameters = queryParameters.set('startDate', <any>startDate);
        }
        if (endDate !== undefined && endDate !== null) {
            queryParameters = queryParameters.set('endDate', <any>endDate);
        }
        if (orgUnit !== undefined && orgUnit !== null) {
            queryParameters = queryParameters.set('orgUnit', <any>orgUnit);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<Array<AggregateData>>(`${this.basePath}/api/Psychotropic/GetPsychotropicOrdersWithNoChangeSixMonthsByPrescriber`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Raw data for Psychtropics With No Change in Six Months (Grid Data).
     * This returns CDifficile Antibiotics.  Data in this call is not aggregated.        Sample Call      http://URL/api/Psychotropic/GetPsychotropicOrdersWithNoChangeSixMonthsData
     * @param requestParameters Contains request parameters: orgList, startDate, endDate, sortFilterDto
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public psychotropicSummaryGetPsychotropicOrdersWithNoChangeSixMonthsData(requestParameters: ApiRequestDto, observe?: 'body', reportProgress?: boolean): Observable<MedicationSummaryResidentContainer>;
    public psychotropicSummaryGetPsychotropicOrdersWithNoChangeSixMonthsData(requestParameters: ApiRequestDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MedicationSummaryResidentContainer>>;
    public psychotropicSummaryGetPsychotropicOrdersWithNoChangeSixMonthsData(requestParameters: ApiRequestDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MedicationSummaryResidentContainer>>;
    public psychotropicSummaryGetPsychotropicOrdersWithNoChangeSixMonthsData(requestParameters: ApiRequestDto, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (requestParameters === null || requestParameters === undefined) {
            throw new Error('Required parameter requestParameters was null or undefined when calling psychotropicSummaryGetPsychotropicOrdersWithNoChangeSixMonthsData.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml',
            'application/x-www-form-urlencoded'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<MedicationSummaryResidentContainer>(`${this.basePath}/api/Psychotropic/GetPsychotropicOrdersWithNoChangeSixMonths`,
            requestParameters,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Percentage of residents on Psychtropics With No Change in Six Months
     * Percentage of total residents in the selected facilities against the number of residents on IV antibiotics in the selected date range                   Sample Call     http://URL/api/Psychotropic/GetPsychotropicOrdersWithNoChangeSixMonthsPercentage?startDate&#x3D;2016-1-1T12:30:00&amp;amp;endDate&#x3D;2017-2-1T12:30:00&amp;amp;orgList&#x3D;10wilm
     * @param requestParameters Contains request parameters: orgList, startDate, endDate
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public psychotropicSummaryGetPsychotropicOrdersWithNoChangeSixMonthsPercentage(requestParameters: ApiRequestDto, observe?: 'body', reportProgress?: boolean): Observable<MedicationSummaryCountResult>;
    public psychotropicSummaryGetPsychotropicOrdersWithNoChangeSixMonthsPercentage(requestParameters: ApiRequestDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MedicationSummaryCountResult>>;
    public psychotropicSummaryGetPsychotropicOrdersWithNoChangeSixMonthsPercentage(requestParameters: ApiRequestDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MedicationSummaryCountResult>>;
    public psychotropicSummaryGetPsychotropicOrdersWithNoChangeSixMonthsPercentage(requestParameters: ApiRequestDto, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (requestParameters === null || requestParameters === undefined) {
            throw new Error('Required parameter requestParameters was null or undefined when calling psychotropicSummaryGetPsychotropicOrdersWithNoChangeSixMonthsPercentage.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml',
            'application/x-www-form-urlencoded'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<MedicationSummaryCountResult>(`${this.basePath}/api/Psychotropic/GetPsychotropicOrdersWithNoChangeSixMonthsPercentage`,
            requestParameters,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Percentage of orders for Psychotropic Medication
     * Percentage of the number of orders on IV and Oral antibiotics over 14 days against antibiotic orders in the selected facilities                   Sample Call     http://URL/api/Psychotropic/GetPsychotropicsPercentage
     * @param requestParams 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public psychotropicSummaryGetPsychotropicsPercentage(requestParams: ApiRequestDto, observe?: 'body', reportProgress?: boolean): Observable<MedicationSummaryCountResult>;
    public psychotropicSummaryGetPsychotropicsPercentage(requestParams: ApiRequestDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MedicationSummaryCountResult>>;
    public psychotropicSummaryGetPsychotropicsPercentage(requestParams: ApiRequestDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MedicationSummaryCountResult>>;
    public psychotropicSummaryGetPsychotropicsPercentage(requestParams: ApiRequestDto, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (requestParams === null || requestParams === undefined) {
            throw new Error('Required parameter requestParams was null or undefined when calling psychotropicSummaryGetPsychotropicsPercentage.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml',
            'application/x-www-form-urlencoded'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<MedicationSummaryCountResult>(`${this.basePath}/api/Psychotropic/GetPsychotropicsPercentage`,
            requestParams,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Percentage of Residents that have more than one Antibiotic
     * Sample Call  http://URL/api/Psychotropic/GetResidentsWithMultiplePRNPsychotropicOrdersPercentage
     * @param requestParameters Contains request parameters: orgList, startDate, endDate
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public psychotropicSummaryGetResidentMultiplePRNPsychotropicOrdersPercentage(requestParameters: ApiRequestDto, observe?: 'body', reportProgress?: boolean): Observable<ResidentCountResult>;
    public psychotropicSummaryGetResidentMultiplePRNPsychotropicOrdersPercentage(requestParameters: ApiRequestDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ResidentCountResult>>;
    public psychotropicSummaryGetResidentMultiplePRNPsychotropicOrdersPercentage(requestParameters: ApiRequestDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ResidentCountResult>>;
    public psychotropicSummaryGetResidentMultiplePRNPsychotropicOrdersPercentage(requestParameters: ApiRequestDto, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (requestParameters === null || requestParameters === undefined) {
            throw new Error('Required parameter requestParameters was null or undefined when calling psychotropicSummaryGetResidentMultiplePRNPsychotropicOrdersPercentage.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml',
            'application/x-www-form-urlencoded'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<ResidentCountResult>(`${this.basePath}/api/Psychotropic/GetResidentsWithMultiplePRNPsychotropicOrdersPercentage`,
            requestParameters,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Raw data  (Grid Data).
     * This returns Antibiotics.  Data in this call is not aggregated.        Sample Call      http://URL/api/Psychotropic/GetResidentsOnPsychotropics
     * @param requestParams Contains request parameters: orgList, startDate, endDate, sortFilterDto
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public psychotropicSummaryGetResidentsOnPsychotropics(requestParams: ApiRequestDto, observe?: 'body', reportProgress?: boolean): Observable<MedicationSummaryResidentContainer>;
    public psychotropicSummaryGetResidentsOnPsychotropics(requestParams: ApiRequestDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MedicationSummaryResidentContainer>>;
    public psychotropicSummaryGetResidentsOnPsychotropics(requestParams: ApiRequestDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MedicationSummaryResidentContainer>>;
    public psychotropicSummaryGetResidentsOnPsychotropics(requestParams: ApiRequestDto, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (requestParams === null || requestParams === undefined) {
            throw new Error('Required parameter requestParams was null or undefined when calling psychotropicSummaryGetResidentsOnPsychotropics.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml',
            'application/x-www-form-urlencoded'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<MedicationSummaryResidentContainer>(`${this.basePath}/api/Psychotropic/GetResidentsOnPsychotropics`,
            requestParams,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Psychotropic Medicaiton by Drug Group
     * Displays top 4 drug groups with the fifth group being \&quot;other\&quot; if a single facility is passed.     If multiple facilities are passed in, the top drug groups are return.  Within each drug group, the facilities making up the top  5 (with #5 being other group if more than 5 facilities are passed in) will be display.  Item count under each facility is the  count of antibiotics that facility has that belongs to that drug group.          Sample Call      http://URL/api/Psychotropic/GetResidentsOnPsychotropicsByDrugGroup
     * @param requestParams Contains request parameters: orgList, startDate, endDate
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public psychotropicSummaryGetResidentsOnPsychotropicsByDrugGroup(requestParams: ApiRequestDto, observe?: 'body', reportProgress?: boolean): Observable<Array<AggregateData>>;
    public psychotropicSummaryGetResidentsOnPsychotropicsByDrugGroup(requestParams: ApiRequestDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<AggregateData>>>;
    public psychotropicSummaryGetResidentsOnPsychotropicsByDrugGroup(requestParams: ApiRequestDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<AggregateData>>>;
    public psychotropicSummaryGetResidentsOnPsychotropicsByDrugGroup(requestParams: ApiRequestDto, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (requestParams === null || requestParams === undefined) {
            throw new Error('Required parameter requestParams was null or undefined when calling psychotropicSummaryGetResidentsOnPsychotropicsByDrugGroup.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml',
            'application/x-www-form-urlencoded'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<Array<AggregateData>>(`${this.basePath}/api/Psychotropic/GetResidentsOnPsychotropicsByDrugGroup`,
            requestParams,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Psychotropic Medicaiton by DrugName
     * Displays top 4 drug groups with the fifth group being \&quot;other\&quot; if a single facility is passed.     If multiple facilities are passed in, the top drug groups are return.  Within each drug group, the facilities making up the top  5 (with #5 being other group if more than 5 facilities are passed in) will be display.  Item count under each facility is the  count of antibiotics that facility has that belongs to that drug group.          Sample Call      http://URL/api/Psychotropic/GetResidentsOnPsychotropicsByDrugName
     * @param requestParams Contains request parameters: orgList, startDate, endDate
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public psychotropicSummaryGetResidentsOnPsychotropicsByDrugName(requestParams: ApiRequestDto, observe?: 'body', reportProgress?: boolean): Observable<Array<AggregateData>>;
    public psychotropicSummaryGetResidentsOnPsychotropicsByDrugName(requestParams: ApiRequestDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<AggregateData>>>;
    public psychotropicSummaryGetResidentsOnPsychotropicsByDrugName(requestParams: ApiRequestDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<AggregateData>>>;
    public psychotropicSummaryGetResidentsOnPsychotropicsByDrugName(requestParams: ApiRequestDto, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (requestParams === null || requestParams === undefined) {
            throw new Error('Required parameter requestParams was null or undefined when calling psychotropicSummaryGetResidentsOnPsychotropicsByDrugName.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml',
            'application/x-www-form-urlencoded'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<Array<AggregateData>>(`${this.basePath}/api/Psychotropic/GetResidentsOnPsychotropicsByDrugName`,
            requestParams,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Psychotropics Medication grouped by facility
     * Queries Antibiotics and returns groupings by facility and then within each facility by drug group.    Count of each group is stored in ItemCount        Sample Call      http://URL/api/Psychotropic/GetResidentsOnPsychotropicsByFacility
     * @param requestParams Contains request parameters: orgList, startDate, endDate
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public psychotropicSummaryGetResidentsOnPsychotropicsByFacility(requestParams: ApiRequestDto, observe?: 'body', reportProgress?: boolean): Observable<Array<AggregateData>>;
    public psychotropicSummaryGetResidentsOnPsychotropicsByFacility(requestParams: ApiRequestDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<AggregateData>>>;
    public psychotropicSummaryGetResidentsOnPsychotropicsByFacility(requestParams: ApiRequestDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<AggregateData>>>;
    public psychotropicSummaryGetResidentsOnPsychotropicsByFacility(requestParams: ApiRequestDto, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (requestParams === null || requestParams === undefined) {
            throw new Error('Required parameter requestParams was null or undefined when calling psychotropicSummaryGetResidentsOnPsychotropicsByFacility.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml',
            'application/x-www-form-urlencoded'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<Array<AggregateData>>(`${this.basePath}/api/Psychotropic/GetResidentsOnPsychotropicsByFacility`,
            requestParams,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Psychotropics grouped by prescriber.
     * This should be used only when a single org unit is selected in the UI.  When multiple org units are selected this call can&#39;t be used  and a different call should be used.    Results will be grouped by Drug Group and then within each group the top 4 prescribers with the 5th being \&quot;Other if there are more than   5 unique prescribers        Sample Call      http://URL/api/Psychotropic/GetResidentsOnPsychotropicsByPrescriber
     * @param requestParams Contains request parameters: orgList, startDate, endDate
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public psychotropicSummaryGetResidentsOnPsychotropicsByPrescriber(requestParams: ApiRequestDto, observe?: 'body', reportProgress?: boolean): Observable<Array<AggregateData>>;
    public psychotropicSummaryGetResidentsOnPsychotropicsByPrescriber(requestParams: ApiRequestDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<AggregateData>>>;
    public psychotropicSummaryGetResidentsOnPsychotropicsByPrescriber(requestParams: ApiRequestDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<AggregateData>>>;
    public psychotropicSummaryGetResidentsOnPsychotropicsByPrescriber(requestParams: ApiRequestDto, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (requestParams === null || requestParams === undefined) {
            throw new Error('Required parameter requestParams was null or undefined when calling psychotropicSummaryGetResidentsOnPsychotropicsByPrescriber.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml',
            'application/x-www-form-urlencoded'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<Array<AggregateData>>(`${this.basePath}/api/Psychotropic/GetResidentsOnPsychotropicsByPrescriber`,
            requestParams,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Grid Data for Residents that have more than one PRN psychotropic medication
     * The list will show a one to one mapping of each resident to a specific medication        Sample Call      http://URL/api/Psychotropic/ResidentsWithMultiplePRNPsychotropicOrders
     * @param requestParameters Contains request parameters: orgList, startDate, endDate, sortFilterDto
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public psychotropicSummaryGetResidentsWithMultiplePRNPsychotropicOrders(requestParameters: ApiRequestDto, observe?: 'body', reportProgress?: boolean): Observable<MedicationSummaryResidentContainer>;
    public psychotropicSummaryGetResidentsWithMultiplePRNPsychotropicOrders(requestParameters: ApiRequestDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MedicationSummaryResidentContainer>>;
    public psychotropicSummaryGetResidentsWithMultiplePRNPsychotropicOrders(requestParameters: ApiRequestDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MedicationSummaryResidentContainer>>;
    public psychotropicSummaryGetResidentsWithMultiplePRNPsychotropicOrders(requestParameters: ApiRequestDto, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (requestParameters === null || requestParameters === undefined) {
            throw new Error('Required parameter requestParameters was null or undefined when calling psychotropicSummaryGetResidentsWithMultiplePRNPsychotropicOrders.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml',
            'application/x-www-form-urlencoded'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<MedicationSummaryResidentContainer>(`${this.basePath}/api/Psychotropic/ResidentsWithMultiplePRNPsychotropicOrders`,
            requestParameters,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Residents that have more than one Psychotropics by facility
     * The list will show a one to one mapping of each resident to a specific medication        Sample Call      http://URL/api/Psychotropic/ResidentsWithMultiplePRNPsychotropicOrdersByFacility
     * @param requestParameters Contains request parameters: orgList, startDate, endDate
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public psychotropicSummaryGetResidentsWithMultiplePRNPsychotropicOrdersByFacility(requestParameters: ApiRequestDto, observe?: 'body', reportProgress?: boolean): Observable<Array<AggregateData>>;
    public psychotropicSummaryGetResidentsWithMultiplePRNPsychotropicOrdersByFacility(requestParameters: ApiRequestDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<AggregateData>>>;
    public psychotropicSummaryGetResidentsWithMultiplePRNPsychotropicOrdersByFacility(requestParameters: ApiRequestDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<AggregateData>>>;
    public psychotropicSummaryGetResidentsWithMultiplePRNPsychotropicOrdersByFacility(requestParameters: ApiRequestDto, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (requestParameters === null || requestParameters === undefined) {
            throw new Error('Required parameter requestParameters was null or undefined when calling psychotropicSummaryGetResidentsWithMultiplePRNPsychotropicOrdersByFacility.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml',
            'application/x-www-form-urlencoded'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<Array<AggregateData>>(`${this.basePath}/api/Psychotropic/ResidentsWithMultiplePRNPsychotropicOrdersByFacility`,
            requestParameters,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Residents that have more than one Antibiotic by prescriber
     * The list will show a one to one mapping of each resident to a specific medication        Sample Call      http://URL/api/Psychotropic/ResidentsWithMultiplePRNPsychotropicOrdersByPrescriber
     * @param requestParameters Contains request parameters: orgList, startDate, endDate
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public psychotropicSummaryGetResidentsWithMultiplePRNPsychotropicOrdersByPrescriber(requestParameters: ApiRequestDto, observe?: 'body', reportProgress?: boolean): Observable<Array<AggregateData>>;
    public psychotropicSummaryGetResidentsWithMultiplePRNPsychotropicOrdersByPrescriber(requestParameters: ApiRequestDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<AggregateData>>>;
    public psychotropicSummaryGetResidentsWithMultiplePRNPsychotropicOrdersByPrescriber(requestParameters: ApiRequestDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<AggregateData>>>;
    public psychotropicSummaryGetResidentsWithMultiplePRNPsychotropicOrdersByPrescriber(requestParameters: ApiRequestDto, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (requestParameters === null || requestParameters === undefined) {
            throw new Error('Required parameter requestParameters was null or undefined when calling psychotropicSummaryGetResidentsWithMultiplePRNPsychotropicOrdersByPrescriber.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml',
            'application/x-www-form-urlencoded'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<Array<AggregateData>>(`${this.basePath}/api/Psychotropic/ResidentsWithMultiplePRNPsychotropicOrdersByPrescriber`,
            requestParameters,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
